import { convertIsoUtcToFormattedLocal } from '../utils';
import { DropdownButton } from '@klv/molecules/dropdown-button';
import useIsHydrated from '@klv/hooks/useIsHydrated';
import { useTranslation } from '@klv/hooks/useTranslation';

import * as s from './styles/NextEventDetails.module.css';

import type { INextEvent } from '@klv/molecules/unified-search-results/types';

interface IProps {
  link: string;
  nextEvents: INextEvent[];
}

const NextEventDetails = ({ link, nextEvents }: IProps) => {
  const { i18n: { language: locale }, t } = useTranslation();

  const isHydrated = useIsHydrated();

  const latestNextEvents =
    nextEvents.slice(0, 4).map((event) => ({
      ...event,
      ...(isHydrated && { start_time: convertIsoUtcToFormattedLocal(event.start_time, locale) }), // format POST hydration
    }));

  if (!latestNextEvents || latestNextEvents.length === 0) {
    return <></>;
  }

  const [firstEvent, ...remainingNextEvents] = latestNextEvents;
  const firstEventId = firstEvent.id;
  const firstEventStartTime = firstEvent.start_time;

  const handleDropdownItemKeyDown = (event: React.KeyboardEvent<HTMLLIElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      window.location.assign(link);
    }
  };

  const dropdownLabel = <p className={s.upcomingDates}>{t('molecule_unifiedSearchResultGridItem_nextEventDetails_upcomingDates')}</p>;

  const dropdownItems = [
    ...remainingNextEvents.map((event) => (
      <p className={s.item} key={event.id}>
        {event.start_time}
      </p>
    )),
  ];

  if (latestNextEvents.length === 1) {
    return (
      <p className={s.dropdownLabel}>
        {firstEventStartTime}
      </p>
    );
  }

  return (
    <DropdownButton
      menuPosition={{ top: '1rem' }}
      dropdownName={`next-event-details-dropdown-${firstEventId}`}
      dropdownItems={dropdownItems}
      dropdownLabel={dropdownLabel}
      showDivider={false}
      variant='transparent'
      onDropdownItemKeyDown={handleDropdownItemKeyDown}
      classNames={{
        button: s.dropdownButton,
        dropdown: s.dropdownMenu,
        icon: s.dropdownIcon,
        label: s.dropdownLabel,
        root: s.dropdownRoot,
      }}
    >
      {firstEventStartTime} 
    </DropdownButton>
  );
};

export default NextEventDetails;
